var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C6.328 11 7 11.672 7 12.5C7 13.328 6.328 14 5.5 14C4.672 14 4 13.328 4 12.5C4 11.672 4.672 11 5.5 11ZM24 5V11C24 11.552 23.553 12 23 12C22.447 12 22 11.552 22 11V7H2V13C2 14.654 3.346 16 5 16H13C13.553 16 14 16.448 14 17C14 17.552 13.553 18 13 18H5C2.243 18 0 15.757 0 13V5C0 2.243 2.243 0 5 0H19C21.757 0 24 2.243 24 5ZM22 5C22 3.346 20.654 2 19 2H5C3.346 2 2 3.346 2 5H22ZM21.5 15.5C21.5 14.121 20.379 13 19 13C17.621 13 16.5 14.121 16.5 15.5C16.5 16.879 17.621 18 19 18C20.379 18 21.5 16.879 21.5 15.5ZM19 19C16.667 19 14.625 20.538 14.034 22.741C13.89 23.275 14.207 23.823 14.741 23.966C15.275 24.109 15.822 23.793 15.966 23.259C16.322 21.929 17.57 21 19 21C20.43 21 21.678 21.929 22.034 23.259C22.154 23.705 22.557 24 22.999 24C23.085 24 23.172 23.989 23.259 23.965C23.793 23.822 24.11 23.274 23.966 22.74C23.375 20.537 21.333 19 19 19Z",
    fill: "#0464B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasportIcon);
export default __webpack_public_path__ + "static/media/pasportIcon.274b2d17a5d126f74da10c0e47054a1e.svg";
export { ForwardRef as ReactComponent };